import React, { useEffect } from 'react';
import './MenuDrawer.css';

const NAV_ITEMS = [
  { view: 'shopping', icon: '🛒', label: 'Shopping List' },
  { view: 'planning', icon: '📅', label: 'Meal Plan' },
  { view: 'meals', icon: '🍜', label: 'Manage Meals' },
  { view: 'staples', icon: '🥛', label: 'Manage Staples' }
];

/**
 * Slide-over navigation drawer anchored to the right edge.
 * Holds everything that used to live in the header tab bar, plus the
 * user identity and the destructive actions moved off the planning page.
 */
function MenuDrawer({
  isOpen,
  onClose,
  activeView,
  onNavigate,
  currentUser,
  isAdmin,
  onStartOver,
  onLogout
}) {
  // Close on Escape and lock body scroll while the drawer is open
  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  return (
    <>
      <div
        className={`menu-backdrop ${isOpen ? 'open' : ''}`}
        onClick={onClose}
        aria-hidden="true"
      />
      <nav
        className={`menu-drawer ${isOpen ? 'open' : ''}`}
        aria-label="Main menu"
        aria-hidden={!isOpen}
      >
        <div className="menu-drawer-header">
          <span className="menu-user">
            👤 {currentUser}
            {isAdmin && <span className="admin-indicator" title="Admin user">⭐</span>}
          </span>
          <button
            onClick={onClose}
            className="menu-close-button"
            aria-label="Close menu"
          >
            ✕
          </button>
        </div>

        <div className="menu-section">
          {NAV_ITEMS.map(({ view, icon, label }) => (
            <button
              key={view}
              className={`menu-item ${activeView === view ? 'active' : ''}`}
              onClick={() => onNavigate(view)}
            >
              <span className="menu-item-icon">{icon}</span>
              <span className="menu-item-label">{label}</span>
            </button>
          ))}
        </div>

        <div className="menu-divider" />

        <div className="menu-section">
          <button className="menu-item constructive" onClick={onStartOver}>
            <span className="menu-item-icon">🔄</span>
            <span className="menu-item-label">Start a New Week</span>
          </button>
          <button className="menu-item destructive" onClick={onLogout}>
            <span className="menu-item-icon">⏻</span>
            <span className="menu-item-label">Logout</span>
          </button>
        </div>
      </nav>
    </>
  );
}

export default MenuDrawer;
